// @flow
import React, {Component} from 'react';
import {
    Table,
    TableBody,
    TableRow,
    TableHeader,
    TableHeaderColumn,
} from 'material-ui/Table';


import ArticleListItem from '../articles/ArticleListItem'

import {withRouter} from 'react-router-dom';

//Pagination
import Pagination from '../controls/pagination/pagination';

import '../ui/table.css';
import {table} from '../../lib/styles/table';

class UserStatsArticleList extends Component {

    renderArticles() {
        if (this.props.viewer.articles.articles.length === 0) {
            return (<tr>
                <td>
                    <div style={{textAlign: 'center'}}>Здесь пока пусто</div>
                </td>
            </tr>)
        }

        return this.props.viewer.articles.articles.map((edge, i) =>
            <ArticleListItem key={i} article={edge} viewer={this.props.viewer} />
        )
    }

    render() {
        return (
            <section>
                <Table className='table' wrapperStyle={{margin: '0 -20px'}}>
                    <TableHeader
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                    >
                        <TableRow style={{border: 0}}>
                            <TableHeaderColumn
                                className="table-cell"
                                style={{width: '37%', ...table.th}}>
                                Заголовок
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                className="table-cell"
                                style={{width: '20%', ...table.th}}>
                                Автор
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                className="table-cell"
                                style={{width: '14%', ...table.th}}>
                                Дата
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                className="table-cell"
                                style={{width: '14.5%', ...table.th}}>
                                Категория
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                className="table-cell"
                                style={{width: '14.5%', ...table.th}}>
                                Тип
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody showRowHover={true} stripedRows={true}>
                        {this.renderArticles()}
                    </TableBody>
                </Table>
                <footer style={{width: '100%', padding: '9px 0'}}>
                    <Pagination
                        totalPage={this.props.totalPages}
                        currentPage={this.props.page}
                        changePage={this.props.onPageChange}
                    />
                </footer>
            </section>
        )
    }
}

export default withRouter(UserStatsArticleList)



// WEBPACK FOOTER //
// src/components/stats/UserStatsArticleList.js